export enum RolesEnum {
    'admin' = "admin",
    'senior_admin' = 'senior_admin',
    'strategy_admin' = "strategy_admin",
    'department_admin' = "department_admin",
    'section_admin' = 'section_admin',
    'section_employee' = 'section_employee',
    'department_secretary' = "department_secretary",
};


export const STRATEGY_EXEC_ROLES = [
    'department_admin',
    'section_admin',
    'section_employee',
    'department_secretary'
]

export interface loginModel {
    username: string;
    password: string;
}
export interface authUser {
    jwt: string;
    username: string;
    id: number;
    department_id: number;
    department_name: string;
    section_id: number | null;
    role: RolesEnum;
    name: string;
    email: string;
    job_title: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    is_deleted: boolean;
    is_in_section: boolean;
    is_in_department: boolean;
    role_name: string;
    admin: boolean;
    strategy_admin: boolean;
    strategy_exec: boolean;
    department_admin: boolean;
    section_admin: boolean;
    senior_admin: boolean;
    section_employee: boolean;
    can_edit_projects: boolean;
    abilities: any
};

export interface SignUpModel {
    id: number
    role: string
    name: string
    username: string
    email: string
    password: string
    job_title: string
    department_id: number
    section_id: number


    roleData?: RoleData
    depData?: DepData
    sectionData?: SectionData
}
export interface RoleData {
    id: number
    name_ar: string
    name_en: string
    description: string
}

export interface DepData {
    id: number
    name: string
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
    sections?: SectionData[];
}

export interface SectionData {
    id: number
    department_id: number
    name: string
    created_at: string
    updated_at: string
    deleted_at: any
    is_deleted: boolean
}